import NotFoundModal from './NotFoundModal.container';

export default NotFoundModal;
